<template>
	<div>
		{{formDate}}
	</div>
</template>

<script>
	export default{
		props:["formDate"],
		data(){
			return{
				
			}
		}
	}
</script>

<style>
</style>
